import { PayloadAction } from '@reduxjs/toolkit';

import { IState, TIsLoading } from '../types';

const statusLoading = (state: IState, action: PayloadAction<TIsLoading>) => {
  state.isLoading = action.payload;
};

export default statusLoading;
